export default "__VITE_ASSET__CJddfzMI__"